import PropTypes from 'prop-types';

import { useNavigate } from 'react-router-dom';

import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import HomeIcon from '@mui/icons-material/Home';

/**
 * NavigateFooter Component
 * 
 * This component displays navigation buttons for navigating to a previous page or a next page.
 * It takes tonBack, and onNext functions as props.
 * 
 * Props:
 * - onBack: A function triggered when the back button is clicked.
 * - onNext: A function triggered when the next button is clicked.
 * - backToHome: A boolean value to determine if the back button should navigate to the home page.
 * - specificActionBackToHome: A function to execute a specific action before navigating back to home.
 */
const NavigateFooter = ({ onBack, onNext, backToHome = false, specificActionBackToHome = null }) => {

    const navigate = useNavigate(); // Hook to programmatically navigate

    /** Handle click on "Retour à l'accueil" */
    const handleBackToHome = () => {
        /** If a specific action is provided, delegate to it (e.g., open a confirm modal) */
        if (typeof specificActionBackToHome === 'function') {
            specificActionBackToHome();
            return;
        }
        /** Fallback: navigate directly to home */
        navigate('/');
    };

    // Render the navigation footer
    return (
        <div className="navigate-footer">

            { /* Navigation buttons */}
            <div className="navigation-buttons">
                {onBack && (
                    <button 
                        onClick={onBack} 
                        className="btn-back"
                    >
                        <ArrowBackIcon style={{ marginRight: '5px' }} /> Retour
                    </button>
                )}

                {backToHome && (
                    <button onClick={handleBackToHome} className="btn-back-to-home">
                        <HomeIcon style={{ marginRight: '5px' }} /> Retour à l&apos;accueil
                    </button>
                )}

                {onNext && (
                    <button 
                        onClick={onNext} 
                        className="btn-next"
                    >
                        Suivant <ArrowForwardIcon style={{ marginLeft: '5px' }} />
                    </button>
                )}
            </div>
        </div>
    );
};

// Prop types for the NavigateFooter component
NavigateFooter.propTypes = {
    onBack: PropTypes.func,
    onNext: PropTypes.func,
    backToHome: PropTypes.bool,
    specificActionBackToHome: PropTypes.func,
};

export default NavigateFooter;